export const getFileViewType = (type: string, view?: string): string => {
  // for any type, ensure that the types are lowercase
  return type === 'creation'
    ? 'document'
    : type === 'board'
    ? view ?? ''
    : type === 'ai querybot'
    ? 'pdf_chat'
    : type;
};

export const getFileViewName = (type: string): string => {
  return type === 'creation' ? 'Document' : type === 'pdf_chat' ? 'AI QueryBot' : type;
};
